import React from "react";

const VARIANT_CLASS_MAP = {
  primary: "btn-primary",
  secondary: "btn-secondary",
  success: "btn-success",
  danger: "btn-danger",
  warning: "btn-warning",
  info: "btn-info",
  light: "btn-light",
  dark: "btn-dark",
  outline: "btn-outline-primary",
  text: "app-btn-text",
};

export const AppButton = ({
  variant = "primary",
  className = "",
  children,
  as = "button",
  ...rest
}) => {
  const Component = as;
  const variantClass = VARIANT_CLASS_MAP[variant] || VARIANT_CLASS_MAP.primary;
  const classes = ["app-btn", variantClass, className].filter(Boolean).join(" ");

  return (
    <Component className={classes} {...rest}>
      {children}
    </Component>
  );
};

export default AppButton;

